import type { CustomIncludedPerilsProps } from 'korint-sdk';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { QuoteContext } from '@folio/modules/shared-quote/QuoteContext';
import {
  FormulaGuaranteeLines,
  isPerilActive,
  useQuotePerils,
  valuedPerilLabel,
  type FormulaGuaranteeLine,
} from './FormulaGuaranteeLines';

const T_PREFIX = 'tutassurHiscoxCyber';

export function IncludedPerilsCyber({ tier }: CustomIncludedPerilsProps) {
  const { t } = useTranslation();
  const { customer } = useContext(QuoteContext);
  const perils = useQuotePerils(tier);

  const worldwideActive = Number(customer?.customFields?.companyRevenueInUSACanada) > 0;
  const damagesSuffered = isPerilActive(perils, 'DOMMAGES_SUBIS');

  const lines: FormulaGuaranteeLine[] = [
    { key: 'BASE_CYBER', label: t(`${T_PREFIX}.perils.BASE_CYBER.label`), active: true },
    { key: 'LOI', label: valuedPerilLabel(t, T_PREFIX, perils, 'LOI'), active: true },
    { key: 'FRANCHISE', label: valuedPerilLabel(t, T_PREFIX, perils, 'FRANCHISE'), active: true },
    {
      key: 'DOMMAGES_SUBIS',
      label: t(`${T_PREFIX}.perils.DOMMAGES_SUBIS.label`),
      active: damagesSuffered,
    },
    // Cyber fraude is gated by Dommages subis (config `showWhen`) — only surface it once offerable.
    ...(damagesSuffered
      ? [
          {
            key: 'CYBER_FRAUDE',
            label: t(`${T_PREFIX}.perils.CYBER_FRAUDE.label`),
            active: isPerilActive(perils, 'CYBER_FRAUDE'),
          },
        ]
      : []),
    { key: 'MONDE_ENTIER', label: t(`${T_PREFIX}.formulaCard.worldwide`), active: worldwideActive },
  ];

  return <FormulaGuaranteeLines lines={lines} />;
}
